import { getLocale } from '@op/opds.opux';
import i18n, { use } from 'i18next';
import { initReactI18next } from 'react-i18next';
import individualLife from './locales';
import { LocalizationNamespace } from './types';

export enum Language {
  fi = 'fi',
  sv = 'sv',
}

export function getCurrentLanguage(): Language {
  const locale = getLocale(document.documentElement.lang);
  if (!Object.values(Language).includes(locale as Language)) {
    return Language.fi;
  }
  return locale as Language;
}

const resources = {
  fi: {
    ...individualLife.fi,
  },
  sv: {
    ...individualLife.sv,
  },
};

export const i18nInitOptions = {
  debug: false,
  defaultNS: LocalizationNamespace.individualLife,
  lng: getCurrentLanguage(),
  fallbackLng: Language.fi,
  ns: Object.values(LocalizationNamespace),
  resources,
  whitelist: Object.keys(Language),
  supportedLngs: Object.keys(Language),
};

void use(initReactI18next).init(i18nInitOptions);
export default i18n;
